export default __webpack_public_path__ + "static/media/flag-singapore.32ce4948.svg";